import React, { useState, useEffect } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Popup from '../Modals/Popup';

const localizer = momentLocalizer(moment);

const CalendarTab = ({ leadData, activeLocations, csLocation, csLocation_type }) => {
  const [myEvents, setMyEvents] = useState([]);
  const [popupData, setPopupData] = useState(null);

  useEffect(() => {
    setMyEvents(leadData.filter(item => activeLocations.includes(item.location)).map((lead,i) => {
      return {
        start:lead.appointment_date_obj,
        end:lead.appointment_date_obj,
        id:i,
        title:lead.full_name,
        name:lead.full_name,
        location:lead.location,
        allDay: true,
      }
    }));

  }, [activeLocations, leadData]);

  const Event = ({ event }) => {
    const l = event.location;
    const formattedStartTime = moment(event.start).format("hh:mm A");
    return (
      <>
      <div className='box-flex'>
        <div className={`boxround ${l === 1 ? "bg-blue" : "bg-green"} me-2`}></div>
        {/*<p className={`time-title text-white ${l === 1 ? "text-blue" : "text-green"}`}>{formattedStartTime}</p>*/}
        <p className="text-white text-[10px] location-title">{event.name}</p>
      </div>
        
      </>
    );
  };

  const DateCellWrapper = ({event}) => {

    /*const eventsForDate = myEvents.filter(item => moment(item.start).isSame(event.start, 'day'));
    console.log(eventsForDate);
    const visibleEvents = eventsForDate.slice(0, 2);
    const hiddenEventsCount = eventsForDate.length - visibleEvents.length;
    console.log(visibleEvents);*/
    return (
      <div className="relative p-1 pt-0">
        <Event key={event.id} event={event} />
      </div>
      /*<div className="relative p-1 pt-0">
        {visibleEvents.map(item => (
          <Event key={item.id} event={item} />
        ))}
        {hiddenEventsCount > 0 && (
          <button
            onClick={() => setPopupData({ date: event, events: eventsForDate })}
            className="showmorebtn" >
            +{hiddenEventsCount} More
          </button>
        )
      </div>*/
    );
  };

  /*const DateCellWrapper = ({ value }) => {
    
    return (
      <div className="relative p-1 pt-0">
        {value}
      </div>
    );
  };*/

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={myEvents}
        startAccessor="start"
        endAccessor="end"
        components={{
            event:DateCellWrapper,
            // Events: DateCellWrapper,
        }}
        style={{ height: 850 }}
        defaultView="month"
        views={['month']}
      />
    </div>
  );
};

export default CalendarTab;
